const enum UILogicActionType {
  SET_SELECTED_CATEGORY_ID = 'SET_SELECTED_CATEGORY_ID',
  SET_IS_SCROLLING = 'SET_IS_SCROLLING',
  SET_SHOW_HEADER_STORE_NAME = 'SET_SHOW_HEADER_STORE_NAME',
  SET_SHOW_MEMBER_DROPDOWN = 'SET_SHOW_MEMBER_DROPDOWN',
  SET_IS_LOADED_LOCALES = 'SET_IS_LOADED_LOCALES',
  SET_SHOW_ATTRIBUTE_MODAL_ALERT = 'SET_SHOW_ATTRIBUTE_MODAL_ALERT',
  SET_ATTRIBUTE_MODAL_ALERT_MSG = 'SET_ATTRIBUTE_MODAL_ALERT_MSG',
  SET_CART_V2_INVIEW = 'SET_CART_V2_INVIEW',
  SET_CART_ERROR_ALERT = 'SET_CART_ERROR_ALERT',
  SET_CART_ERROR_ALERT_MSG = 'SET_CART_ERROR_ALERT_MSG',
  SET_CART_SELECTED_PAY_METHOD_ALERT = 'SET_CART_SELECTED_PAY_METHOD_ALERT',
  SET_SHAREMEAL_RULE_OPEN = 'SET_SHAREMEAL_RULE_OPEN',
  SET_PRICEPOINT_RULE_OPEN = 'SET_PRICEPOINT_RULE_OPEN',
  SET_IS_CART_CTA_STATUS_DISABLED = 'SET_IS_CART_CTA_STATUS_DISABLED',
  SET_IS_CART_PREORDERTIME_VALID = 'SET_IS_CART_PREORDERTIME_VALID',
}

export { UILogicActionType };
